import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, CardTitle, Button, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter, } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const PartSelection = () => {
  const itemsPerPage = 5;
  const authToken = localStorage.getItem("access");
  // const authToken = JSON.parse(localStorage.getItem("authUser")).token;
  const [modalVisible, setModalVisible] = useState(false);
  const [machines, setMachines] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMachine, setSelectedMachine] = useState("");
  const [childParts, setChildParts] = useState([]);
  const [selectedChildPart, setSelectedChildPart] = useState(4);
  const [selectedOperator, setSelectedOperator] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [operators, setOperators] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [responseMessage, setResponseMessage] = useState("");
  const [responseData, setResponseData] = useState([]);
  const [productionData, setProductionData] = useState([]);
const [machineDescription, setMachineDescription] = useState("");
const [partDescription, setPartDescription] = useState("");
const navigate = useNavigate();
  useEffect(() => {
     fetchProductionSetup();
  }, []);
    const fetchProductionSetup = async () => {
    try {
      setIsLoading(true);
      const response = await fetch("https://api.hanoch.in/production-film/production-setup", {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, 
        // },
      });
      if (response.ok) {
        const data = await response.json();
        setProductionData(data);
      } else if (response.status === 401) {
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };


  function getTodayDate() {
    const today = new Date();
    return today.toISOString().split("T")[0];
  }

  const fetchMachines = async () => {
    try {
      const response = await fetch("https://api.hanoch.in/api/machines",
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${authToken}`,
        //   },
        // }
      );

      if (response.ok) {
        const machines = await response.json();
        setMachines(machines);
        setSelectedMachine(machines[0].id)

      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("access");
        // localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const isShiftDisabled = (shift) => {
    const now = new Date();
    const currentHour = now.getHours();

    if (shift === "1") {
      return currentHour < 6; // After 2 PM, Shift 1 is over
    } else if (shift === "2") {
      return currentHour < 14; // After 10 PM, Shift 2 is over
    } else if (shift === "3") {
      return currentHour < 22 && currentHour >= 6;
      // Shift 3 (10PM-6AM) is *upcoming* if it's between 6 AM to 10 PM
    }
    return false;
  };
  const getCurrentShift = () => {
    const now = new Date();
    const hours = now.getHours();

    if (hours >= 6 && hours < 14) {
      return 1; // Shift 1: 6am to 2pm
    } else if (hours >= 14 && hours < 22) {
      return 2; // Shift 2: 2pm to 10pm
    } else {
      return 3; // Shift 3: 10pm to 6am
    }
  };
  const [selectedShift, setSelectedShift] = useState(getCurrentShift());

  const [formData, setFormData] = useState({
    machine_id: "",
    part_id: "",
    shift: getCurrentShift(),
    date: getTodayDate(),
    operator_id: "",
    priority:"",
    pending_qty:"",
    pending_hrs:"",
  });
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.machine_id || !formData.part_id || !formData.shift || !formData.date || !formData.operator_id) {
      toast.error("All fields are required.");
      return;
    }
    try {

      setIsLoading(true);
      const apiUrl =
        "https://api.hanoch.in/production-film/production-setup/";

      const formDataObject = new FormData();
      formDataObject.append("machine", formData.machine_id);
      formDataObject.append("part", formData.part_id);
      formDataObject.append("shift", formData.shift);
      formDataObject.append("date", formData.date);
      formDataObject.append("operator", formData.operator_id);
        formDataObject.append("priority", formData.priority);
          formDataObject.append("pending_hrs", formData.pending_hrs);
            formDataObject.append("pending_qty", formData.pending_qty);
      const response = await fetch(apiUrl, {
        method: "POST",
        // headers: {
        //   Authorization: `Bearer ${authToken}`,
        // },
        body: formDataObject,
      });

      const responseData = await response.json();
      //  setResponseData(responseData)
      if (response.ok) {
        toast.success(responseData.message);
        setModalVisible(false);
        setFormData({
          machine_id: "",
          part_id: "",
          shift: "",
          date: "",
          operator_id: ""

        });
        fetchProductionSetup();
      } else {
        toast.error(`Error: ${responseData.error}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setIsLoading(false);
    }

  };


 

  const handleMachineChange = async (event) => {
     const selectedId = event.target.value;
    setSelectedMachine(event.target.value);
    setFormData((prev) => ({ ...prev, machine_id: selectedId }));
 const selectedMachineObj = machines.find((m) => m.id === parseInt(selectedId));
  if (selectedMachineObj) {
    setMachineDescription(selectedMachineObj.description || "");
  }
  };
const handlePriorityChange=async (event)=>{
  const selectedId=event.target.value;
   setFormData((prev) => ({ ...prev, priority: selectedId }));
}
const handlePendinghrsChange=async (event)=>{
  const selectedId=event.target.value;
   setFormData((prev) => ({ ...prev, pending_hrs: selectedId }));
}
const handlePendingqtyChange=async (event)=>{
  const selectedId=event.target.value;
   setFormData((prev) => ({ ...prev, pending_qty: selectedId }));
}
  const fetchChildParts = async () => {
    try {
      const response = await fetch(
        "https://api.hanoch.in/api/parts",
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${authToken}`, // Replace with your actual token
        //   },
        // }
      );
      if (response.ok) {
        const childParts = await response.json();

        setChildParts(childParts);
      
        //selectedChildPart(data[0].number)

      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchOperator = async () => {
    try {
      const response = await fetch(
        "https://api.hanoch.in/users/operators",
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${authToken}`, // Replace with your actual token
        //   },
        // }
      );
      if (response.ok) {
        const data = await response.json();
        console.log("data", data)
        setOperators(data);
        //selectedChildPart(data[0].number)

      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

 const handleChildPartChange = (event) => {
  const selectedId = event.target.value;
   setSelectedChildPart( event.target.value);
   
  setFormData((prev) => ({ ...prev, part_id: selectedId }));
 const selectedPartObj = childParts.find((m) => m.id === parseInt(selectedId));
 
 if (selectedPartObj) {
    setPartDescription(selectedPartObj.description || "");
  }
};


  const getAllChildPartValues = () => {
    const allChildParts = [];
    if (childParts && childParts.length > 0) {
      childParts.forEach(item => {
        if (item.childParts && item.childParts.length > 0) {
          item.childParts.forEach(childPart => {
            if (childPart.value) {
              allChildParts.push(childPart.value);
            }
          });
        }
      });
    }
    return [...new Set(allChildParts)];
  };
  const handleShiftChange = (event) => {
    const newShift = event.target.value;
    setSelectedShift(newShift);
    setFormData((prev) => ({ ...prev, shift: newShift }));
  };
  const handleOperatorChange = (event) => {
    const operatorId = event.target.value;
    setSelectedOperator(operatorId)
    setFormData((prev) => ({ ...prev, operator_id: operatorId }));
  }

  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setSelectedDate(newDate);
    setFormData((prev) => ({ ...prev, date: newDate }));
  };
  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredPart = productionData.filter((part) =>
    (part.name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredPart.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = filteredPart.slice(indexOfFirstItem, indexOfLastItem);

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const toggleModal = () => {
     const willOpen = !modalVisible;
     if(willOpen){
fetchMachines();
    fetchChildParts();
    fetchOperator();
     }
    setModalVisible(willOpen);
    
    
  }




  return (

    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Production Setup" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">
                    Add
                  </h4>
                </CardHeader>
                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div className="d-flex gap-1">
                          <Button
                            color="success"
                            className="add-btn"
                            onClick={toggleModal}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {isLoading ? (
                      <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive table-card mt-3 mb-1">
                        <table
                          className="table align-middle table-nowrap"
                          id="customerTable"
                        >
                          <thead className="table-light">
                            <tr>
                              <th className="sort" data-sort="customer_name">
                                Date
                              </th>
                              <th className="sort" data-sort="email">
                                Machine Name
                              </th>
                              <th className="sort" data-sort="phone">
                                Part Name
                              </th>

                              <th className="sort" data-sort="action">
                                Shift
                              </th>
 <th className="sort" data-sort="action">
                                Priority
                              </th>
                               <th className="sort" data-sort="action">
                                Pending Qty
                              </th>
                               <th className="sort" data-sort="action">
                           Pending Hrs
                              </th>
                              <th className="sort" data-sort="action">
                                operator
                              </th>
                            </tr>
                          </thead>
                          <tbody className="list form-check-all">
                            {currentItems === undefined ? (
                              <tr>
                                <td colSpan="9" className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : currentItems.length === 0 ? (
                              <tr>
                                <td colSpan="9" className="text-center">
                                  No content found
                                </td>
                              </tr>
                            ) : (
                              currentItems.map((part, index) => (
                                <tr key={index}  onClick={() => navigate("/batch-control-page", { state: { part } })} 
                                style={{
                      cursor: "pointer"}} >

                                  <td className="part_name">
                                    {part.date}
                                  </td>
                                  <td className="part_number">
                                    {part.machine_name}
                                  </td>
                                  <td className="email">
                                    {part.part_name}
                                  </td>
                                  <td className="email">
                                    {part.shift}
                                  </td>
                                   <td className="email">
                                    {part.priority}
                                  </td>
                                   <td className="email">
                                    {part.pending_hrs}
                                  </td>
                                   <td className="email">
                                    {part.pending_qty}
                                  </td>
                                  <td className="email">
                                    {part.operator_name}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                        <div className="noresult" style={{ display: "none" }}>
                          <div className="text-center">
                            <lord-icon
                              src="https://cdn.lordicon.com/msoeawqm.json"
                              trigger="loop"
                              colors="primary:#121331,secondary:#08a88a"
                              style={{ width: "75px", height: "75px" }}
                            ></lord-icon>
                            <h5 className="mt-2">Sorry! No Result Found</h5>
                            <p className="text-muted mb-0">
                              We've searched more than 150+ Orders We did not find
                              any orders for you search.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${currentPage === 1 ? "disabled" : ""
                            }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${currentPage === totalPages ? "disabled" : ""
                            }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>


      <Modal
        isOpen={modalVisible}
        toggle={() => {
          setModalVisible(false);
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
          toggle={() => {
            toggleModal();
          }}
        >

        </ModalHeader>
        {responseMessage && (
          <div
            className={`alert ${responseMessage.includes("Error")
                ? "alert-danger"
                : "alert-success"
              } `}
          >
            {responseMessage}
          </div>
        )}
        <form className="tablelist-form">
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="part-description" className="form-label">
                select date
              </label>
              <div className="col-md-10">

                <input
                  type="date"
                  value={formData.date}
                  onChange={handleDateChange}
                  max={new Date().toISOString().split('T')[0]}  // restrict future date

                />  </div>
            </div>
            <div className="mb-3" id="modal-id">
              <label htmlFor="id-field" className="form-label">
                Select machine
              </label>
              <select
                className="form-control"
                id="machine"
                name="machine_id"
                value={formData.machine_id}
                onChange={handleMachineChange}
              >
                <option value="">Select a machine</option>
                {machines?.map((machine) => (
                  <option key={machine.id} value={machine.id}>
                    {machine.name}
                  </option>
                ))}

              </select>
            </div>
  <div className="mb-3" id="modal-id">
              <label htmlFor="id-field" className="form-label">
                Machine description
              </label>
              <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      id="flash"
                      name="machineDescription"
                       value={machineDescription}
                     readOnly
                     
                    />
        
            </div>
            <div className="mb-3">
              <label htmlFor="part_name-field" className="form-label">
                select Part Name
              </label>

              <select
                className="form-control"
                id="part"
                name="partName"
                value={formData.partName}
                onChange={handleChildPartChange}

              >
                <option value="">Select a part name</option>
                {childParts.map((partValue, index) => (
                  <option key={index} value={partValue.id}>
                    {partValue.name}
                  </option>
                ))}
              </select>
            </div>
 <div className="mb-3">
              <label htmlFor="part_name-field" className="form-label">
                Part number description
              </label>
              <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      id="flash"
                      name="partDescription"
                       value={partDescription}
                     readOnly
                     
                    />
 
           
              
            </div>
            <div className="mb-3">
              <label htmlFor="topic-field" className="form-label">
                select shift
              </label>
              <select
                className="form-control"
                id="shift"
                name="shift"
                value={formData.shift}
                onChange={handleShiftChange}
              >
                <option value="" >Select a shift</option>
                <option value="1" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("1")} >6-2 (Shift 1)</option>
                <option value="2" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("2")}>2-10 (Shift 2)</option>
                <option value="3" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("3")}>10-6 (Shift 3)</option>
              </select>
            </div>
             <div>
                  <label htmlFor="flash" className="col-form-label">
                  Priority
                  </label>
                  <div className="col-md-10">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      id="priority"
                      name="priority"
                      value={formData.priority}
                      onChange={handlePriorityChange}
                    />
                  </div>
                  </div>
                  <div>
                  <label htmlFor="flash" className="col-form-label">
                  Pending pending_qty
                  </label>
                  <div className="col-md-10">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      id="pending_qty"
                      name="pending_qty"
                      value={formData.pending_qty}
                      onChange={handlePendingqtyChange}
                    />
                  </div>
                  </div>
                  <div>
                  <label htmlFor="flash" className="col-form-label">
                  Pending Hrs
                  </label>
                  <div className="col-md-10">
                    <input
                      className="form-control"
                      type="number"
                      placeholder=""
                      id="pending_hrs"
                      name="pending_hrs"
                      value={formData.pending_hrs}
                      onChange={handlePendinghrsChange}
                    />
                  </div>
                  </div>
            <div className="mb-3">
              <label htmlFor="part-description" className="form-label">
                Operator name
              </label>
              <select
                className="form-control"
                id="operatorName"
                name="operator_id"
                value={formData.operator_id}
                onChange={handleOperatorChange}

              >
                <option value="">Select a operator name</option>
                {operators.map((operator, index) => (
                  <option key={index} value={operator.id}>
                    {operator.name}
                  </option>
                ))}
              </select>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                onClick={handleSubmit}
              >Save
                {" "}

              </button>
              {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
            </div>
          </ModalFooter>
        </form>
      </Modal>

    </React.Fragment>

  );
};

export default PartSelection;
